<script>
import { Page } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'

export default {
  extends: PageFormBase,
  data() {
    return {
      redirectRoute: { name: 'Pages List' },
      livePreview: true
    }
  },
  computed: {
    service() {
      return Page
    },
    livePreviewUrl() {
      const readOnlySlugs = ['contact', 'about', 'services']
      if (readOnlySlugs.includes(this.form.slug_pl)) {
        return `/${this.form.slug_pl}`
      } else if (this.form.slug_pl === 'home') {
        return '/preview'
      } else {
        return '/preview/slug'
      }
    }
  },
  methods: {
    getGeneralFields() {
      return [
        new fields.Input({
          label: 'Tytuł',
          modelPath: [this, 'form', 'title'],
          multilingual: true,
          required: true,
          requiredInAllLanguages: true
        }),
        new fields.Image({
          label: 'Zdjęcie',
          modelPath: [this, 'form', 'image'],
          multilingual: true,
          copyTo: { og_image: { stripHtml: false } }
        }),
        new fields.Switch({
          label: 'Ukryta',
          modelPath: [this, 'form', 'is_hidden']
        }),
        new fields.Switch({
          label: 'Pokaż menu boczne',
          modelPath: [this, 'form', 'show_sided_menu']
        })
      ]
    }
  }
}
</script>
